import { NewFilter } from '@/types/NewFilter';

export const filters: NewFilter[] = [
	{
		key: 'status',
		name: 'Status',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'employee',
		name: 'Colaborador',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'trainings',
		name: 'Treinamento',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'types',
		name: 'Tipo de Mudança',
		isMulti: true,
		isDisabled: () => false,
	},
];
